var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserTable',{attrs:{"url":_vm.url,"countUrl":_vm.countUrl,"timeRange":_vm.timeRange}}),_c('UserDetails',{attrs:{"monAppId":_vm.monAppId,"timeRange":_vm.timeRange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }